import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

import { Container, Jumbo, Tabs, tokens } from '@treams/treams-ui';

import TalentReviewEditorWithID from './TalentReviewEditor';
import TalentReviewsListContainer from './TalentReviewsListContainer';

export default function TalentReviewsSettings() {
	const { t } = useTranslation();

	return (
		<>
			<Jumbo
				title={t('settings.talentReviews.title')}
				description={t('settings.talentReviews.description')}
				footer={
					<Tabs.Container mb="-1px">
						<Tabs.Item
							title={t('settings.talentReviews.title')}
							path={['/settings/talent-reviews', '/settings/talent-reviews/:id']}
						/>
					</Tabs.Container>
				}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Switch>
					<Route path="/settings/talent-reviews/new">
						<TalentReviewEditorWithID />
					</Route>
					<Route path="/settings/talent-reviews/:id">
						{({ match }) => <TalentReviewEditorWithID id={match!.params.id} />}
					</Route>
					<Route>
						<TalentReviewsListContainer />
					</Route>
				</Switch>
			</Container>
		</>
	);
}
